// Components/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useUser } from '../Context/UserContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user } = useUser();

  if (!user) return <Navigate to="/" replace />;

  if (user.role !== requiredRole) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
